// extracted by mini-css-extract-plugin
module.exports = {"divider":"commodityiconlist_divider__1nL_H"};